<template>
  <div class="promotion-streamMedia" :class="{'en-style': language === 'en'}">
      <div class="container-top">
        <plex-header class="" style="width:100%"></plex-header>
        <div class="banner-wrap container">
          <h3 class="title">{{$t('banner_title')}}</h3>
          <div class="content">
            <div class="left-wrap">
              <p class="des">
                {{$t('banner_des1')}}
              </p>
              <p class="des">
                {{$t('banner_des2')}}
              </p>
              <router-link to="/">{{$t('banner_btn')}}</router-link>
            </div>
            <div class="right-wrap">
              <img  class="" src="../../../../static/img/promotion/streamMedia-right.png" alt="">
            </div>
          </div>
        </div>
        <img  class="right-img" src="../../../../static/img/promotion/streamMedia-right.png" alt="">
      </div>

    <div class="container">

      <div class="whyneed-wrap">
        <h3 class="title">{{$t('whyNeed_title')}}</h3>
        <div class="content">
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img1.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des1')}}</p>
          </div>
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img2.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des2')}}</p>
          </div>
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img3.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des3')}}</p>
          </div>
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img4.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des4')}}</p>
          </div>
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img5.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des5')}}</p>
          </div>
          <div class="item">
            <div class="img-wrap">
              <img src="../../../../static/img/promotion/streamMedia-whyneed-img6.png" alt="">
            </div>
            <p class="des">{{$t('whyNeed_des6')}}</p>
          </div>
        </div>
      </div>
      <div class="benefit-wrap">
          <h3 class="title">{{$t('benefit_title')}}</h3>
          <div class="benefit">
            <div class="content">
              <div class="box ">
                <div class="item">
                  <div class="img-wrap">
                    <img src="../../../../static/img/promotion/streamMedia-benefit1.png" alt="">
                  </div>
                  <div class="des">
                    {{$t('benefit_item1')}}
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap">
                  <img src="../../../../static/img/promotion/streamMedia-benefit2.png" alt="">
                  </div>
                  <div class="des">
                    {{$t('benefit_item2')}}
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap">
                  <img src="../../../../static/img/promotion/streamMedia-benefit3.png" alt="">
                  </div>
                  <div class="des">
                    {{$t('benefit_item3')}}
                  </div>
                </div>
                <div class="item">
                  <div class="img-wrap">
                  <img src="../../../../static/img/promotion/streamMedia-benefit4.png" alt="">
                  </div>
                  <div class="des">
                    {{$t('benefit_item4')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <router-link to="/download" class="down-btn">{{$t('downloadPlex')}}</router-link>
      </div>

      <div class="stream-list-wrap">
        <h4 class="title">{{$t('stream_list_title')}}</h4>
        <div class="content content1">
          <div class="box">
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-netflix.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title1')}}</h4>
                <p class="des">{{$t('stream_list_des1')}}</p>
              </div>
              <div class="movie-wrap">
                <h4 class="title">{{$t('stream_list_moive')}}</h4>
                <p class="name">{{$tc('stream_list_moive1', 0)}}</p>
                <p class="name">{{$tc('stream_list_moive1', 1)}}</p>
                <p class="name">{{$tc('stream_list_moive1', 2)}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-bbc.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title2')}}</h4>
                <p class="des">{{$t('stream_list_des2')}}</p>
              </div>
              <div class="movie-wrap">
                <h4 class="title">{{$t('stream_list_moive')}}</h4>
                <p class="name">{{$tc('stream_list_moive2', 0)}}</p>
                <p class="name">{{$tc('stream_list_moive2', 1)}}</p>
                <p class="name">{{$tc('stream_list_moive2', 2)}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-hulu.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title3')}}</h4>
                <p class="des">{{$t('stream_list_des3')}}</p>
              </div>
              <div class="movie-wrap">
                <h4 class="title">{{$t('stream_list_moive')}}</h4>
                <p class="name">{{$tc('stream_list_moive3', 0)}}</p>
                <p class="name">{{$tc('stream_list_moive3', 1)}}</p>
                <p class="name">{{$tc('stream_list_moive3', 2)}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-hbo.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title4')}}</h4>
                <p class="des">{{$t('stream_list_des4')}}</p>
              </div>
              <div class="movie-wrap">
                <h4 class="title">{{$t('stream_list_moive')}}</h4>
                <p class="name">{{$tc('stream_list_moive4', 0)}}</p>
                <p class="name">{{$tc('stream_list_moive4', 1)}}</p>
                <p class="name">{{$tc('stream_list_moive4', 2)}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-disney.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title5')}}</h4>
                <p class="des">{{$t('stream_list_des5')}}</p>
              </div>
              <div class="movie-wrap">
                <h4 class="title">{{$t('stream_list_moive')}}</h4>
                <p class="name">{{$tc('stream_list_moive5', 0)}}</p>
                <p class="name">{{$tc('stream_list_moive5', 1)}}</p>
                <p class="name">{{$tc('stream_list_moive5', 2)}}</p>
              </div>
            </div>

          </div>
        </div>
        <div class="dots-wrap dots-wrap1">
          <span class="active"></span>
          <span></span>
          <span></span>
        </div>
        <div class="content content2">
          <div class="box">
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-niconico.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title6')}}</h4>
                <p class="des">{{$t('stream_list_des6')}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-viu.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title7')}}</h4>
                <p class="des">{{$t('stream_list_des7')}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-abema.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title8')}}</h4>
                <p class="des">{{$t('stream_list_des8')}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-tver.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title9')}}</h4>
                <p class="des">{{$t('stream_list_des9')}}</p>
              </div>
            </div>
            <div class="item">
              <div class="img-wrap">
                <img src="../../../../static/img/promotion/stream-list-dmm.png" alt="">
              </div>
              <div class="info-wrap">
                <h4 class="title">{{$t('stream_list_title10')}}</h4>
                <p class="des">{{$t('stream_list_des10')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="dots-wrap dots-wrap2">
          <span class="active"></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="features">
        <h4>{{$t('feature_title')}}</h4>
        <div class="ftu-text1">
          <div>
            <span>{{$t('features_title1')}}</span>
            <span class="small">{{$t('features_con1')}}</span>
          </div>
          <div>
            <span>{{$t('features_title2')}}</span>
            <span class="small">{{$t('features_con2')}}</span>
          </div>
          <div>
            <span>{{$t('features_title3')}}</span>
            <span class="small">{{$t('features_con3')}}</span>
          </div>
        </div>
        <div class="ftu-text2">
          <div>
            <span>{{$t('features_title4')}}</span>
            <span class="small">{{$t('features_con4')}}</span>
          </div>
          <div>
            <span>{{$t('features_title5')}}</span>
            <span class="small">{{$t('features_con5')}}</span>
          </div>
          <div>
            <span>{{$t('features_title6')}}</span>
            <span class="small">{{$t('features_con6')}}</span>
          </div>
        </div>
        <router-link to="/" class="down-btn">{{$t('getPlex')}}</router-link>
      </div>

    </div>
    <div class="footer">
      <img class="footer-icon" v-if="language === 'zh'" src="../../../../static/img/promotion/netflix-footer-icon.png" alt="">
      <img class="footer-icon" v-if="language === 'en'" src="../../../../static/img/promotion/netflix-footer-icon-en.png" alt="">
      <p>{{$t('footer_con1')}}</p>
      <div class="star-wrap">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
        <img class="" src="../../../../static/img/promotion/netflix-star.png" alt="">
      </div>
      <router-link to="/download" class="down-btn">{{$t('downloadPlex')}}</router-link>
    </div>
</div>
</template>

<script>
import locales from './lang'
import PlexHeader from '../../../components/plexHeader/mainHeader/Index.vue'
import cookie from '../../../lib/cookie'

export default {
  name: 'promotion-stream-media',
  components: {PlexHeader},
  locales,
  created: function () {
    this.$store.commit('isSpecialHeader', true)
    cookie.setCookie('promotion_source', 'promotion-streamMedia', 30)
  },
  destroyed() {
    this.$store.commit('isSpecialHeader', false)
  },
  mounted() {
    this.initDots()
  },
  computed: {
    language() {
      return this.$store.state.currentLang
    }
  },
  methods: {
    initDots() {
      let box = document.querySelector('.stream-list-wrap .box')
      let content1 = document.querySelector('.stream-list-wrap .content1')
      let content2 = document.querySelector('.stream-list-wrap .content2')
      let dots1 = document.querySelectorAll('.dots-wrap1 span')
      let dots2 = document.querySelectorAll('.dots-wrap2 span')
      content1.addEventListener('scroll', () => {
        for (let i = 0; i < dots1.length; i++) {
          dots1[i].className = ''
        }
        dots1[(parseInt(((content1.scrollLeft + (content1.offsetWidth / 2)) / box.offsetWidth) / 0.33))].className = 'active'
      }, false)
      content2.addEventListener('scroll', () => {
        for (let i = 0; i < dots2.length; i++) {
          dots2[i].className = ''
        }
        dots2[(parseInt(((content2.scrollLeft + (content2.offsetWidth / 2)) / box.offsetWidth) / 0.33))].className = 'active'
      }, false)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/common.scss";
.promotion-streamMedia {
  font-family: MicrosoftYaHei;
  position: relative;
  .main-header-pc {
    z-index: 999 !important;
  }
  .container-top {
    position: relative;
    width: 100%;
    background-image: url(../../../../static/img/promotion/netflix-banner.png);
    background-repeat: no-repeat;
    position: relative;
    background-size: 100% 100%;
    .title {
      font-size: 62px;
      color: #fff;
      margin: 95px 0 160px;
      padding-left: 10%;
    }
    .banner-wrap {
      max-width: 1680px;
      position: relative;
      z-index: 2;
      .content {
        display: flex;
        > div {
          width: 47%;
        }
        .left-wrap {
          padding-bottom: 115px;
          padding-left: 10%;
          .des {
            font-size: 24px;
            color: #fff;
            line-height: 62px;
            margin: 0;
          }
          a {
            display: block;
            max-width: 445px;
            height: 90px;
            color: #9761fd;
            background-color: #fff;
            font-size: 24px;
            line-height: 90px;
            text-align: center;
            margin-top: 55px;
          }
        }
        .right-wrap {
          position: relative;
          img {
            display: none;
          }
        }
      }
    }
    .right-img {
      right: 11%;
      bottom: 0;
      max-width: 680px;
      position: absolute;
      z-index: 1;
    }
    @media screen and (max-width: 1600px) {
      .right-img {
        right: 5%;
        bottom: 0;
        max-width: 620px;
        position: absolute;
        z-index: 1;
      }
    }
    @media screen and (max-width: 1440px) {
      .title {
        margin: 55px 0px;
        padding-left: 5%;
        font-size: 34px;
        line-height: 40px;
      }
      .banner-wrap {
        .content {
          flex-wrap: wrap;
          .left-wrap {
            width: 60%;
            padding: 0 5% 40px;
            .des {
              font-size: 20px;
              line-height: 40px;
            }
            a {
              margin-top: 30px;
            }
          }
          .right-wrap {
            width: 40%;
            text-align: center;
            img {
              max-width: 100%;
            }
          }
        }
      }
      .right-img {
        width: 400px;
      }
    }
    @media screen and (max-width: 1000px) {
      .title {
        margin: 25px 0px 0;
        padding: 0 8% 30px;
        font-size: 34px;
        line-height: 40px;
      }
      .banner-wrap {
        .content {
          flex-direction: column;
          .left-wrap {
            width: 100%;
            padding: 0 8% 50px;
            .des {
              font-size: 16px;
              line-height: 34px;
            }
            a {
              height: 66px;
              line-height: 66px;
            }
          }
          .right-wrap {
            width: 100%;
            text-align: center;
            img {
              display: inline;
              max-width: 80%;
            }
          }
        }
      }
      .right-img {
        display: none;
      }
    }
  }

  .down-btn {
    display: inline-block;
    height: 66px;
    width: 350px;
    margin: 40px 0 80px;
    font-size: 24px;
    letter-spacing: 1.4px;
    line-height: 66px;
    color: #ffffff;
    text-align: center;
    background: linear-gradient(125.23deg, #416cf8 0%, #ec55ff 100%);
  }
  @media screen and (max-width: 768px) {
    .down-btn {
      margin: 20px 0 20px;
      width: 300px;
    }
  }
  .container {
    z-index: 11;
    max-width: 1200px;
    padding: 0;
    margin: 0 auto;
    background: transparent;

  .whyneed-wrap{
    padding: 80px 0 0;
    .title {
      font-size: 36px;
      color: #333;
      font-weight: 600;
      margin: 0 0 40px;
      text-align: center;
    }
    .content{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item{
        width: 387px;
        margin-bottom: 20px;
        .img-wrap{
          width: 100%;
          height: 310px;
          box-shadow: 0 4px 10px 1px #ececec;
          img{
            max-width: 100%;
          }
        }
        .des{
          height: 70px;
          line-height: 70px;
          font-size: 24px;
          color: #333;
          text-align: center;
          margin-bottom: 0px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .whyneed-wrap{
      padding: 30px 0 0;
      .content{
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 5% 20px;
        .item{
          margin: 0 15px;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .whyneed-wrap{
      padding: 30px 0 0;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: 600;
        margin: 0 0 40px;
        text-align: center;
      }
      .content{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0 0 20px;
        .item{
          width: 140px;
          margin: 0 5%;
          .img-wrap{
            height: 110px;
          }
          .des{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
          }
        }

      }
    }
  }
  .benefit-wrap {
    text-align: center;
    padding: 80px 0 0;
    .title {
      font-size: 36px;
      color: #333;
      font-weight: 600;
      margin: 0 0 40px;
      text-align: center;
    }
      .benefit{
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        .content{
          max-width: 1200px;
          .box{
            padding: 1px;
            display: flex;
            flex-wrap: wrap;
            transition: all 0.5s;
            left: 0;
            position: relative;
            .item{
              width: 285px;
              background-color: #fff;
              box-shadow: 0 0 5px 1px #e3e3e3;
              margin:0 6px 20px 6px ;
              .img-wrap{
                height: 240px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                img{
                  margin: 15px 0 0;
                }
              }
              .des{
                font-size: 18px;
                text-align: center;
                height: 88px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                text-align: left;
                padding: 0 20px;
                box-shadow: 0 0 8px 1px #ccc;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 1200px) {
      .benefit-wrap {
        .benefit{
          position: relative;
          .content{
            .box{
              width: 100% !important;
              display: flex;
              justify-content: center;
              .item{
                width: 300px;
                float: none;
                margin: 10px 30px;
                .des{
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 768px) {
      .benefit-wrap {
        text-align: center;
        padding: 30px 0 0;
        .title {
          padding: 0 8% 0px;
          font-size: 18px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .benefit{
          position: relative;
          .content{
            .box{
              width: 100% !important;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .item{
                width: 300px;
                float: none;
                margin: 10px 0;
                .des{
                  height: 60px;
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }

    .stream-list-wrap{
      position: relative;
        >.title {
          padding: 0 20px;
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin: 0 0 40px;
          text-align: center;
        }
        .content{
          scroll-behavior: smooth;
          .box{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .item{
              box-shadow: 0 0 5px 1px #e3e3e3;
              width: calc(20% - 20px);
              margin-bottom: 20px;
              padding: 20px;
              .img-wrap{
                img{
                  max-width: 100%;
                  height: 76px;
                }
              }
              .info-wrap{
                .title{
                  font-size: 14px;
                  height: 30px;
                  text-align: left;
                  color: #000;
                }
                .des{
                  font-size: 14px;
                  color: #666;
                  height: 140px;
                  margin: 0;
                }
              }
              .movie-wrap{
                .title{
                  font-size: 14px;
                  color: #333;
                  font-weight: bold;
                  margin-top: 0;
                }
                .name{
                  margin: 5px 0;
                }
              }
            }
          }
        }
        .dots-wrap{
          display: none;
        }
    }

    @media screen and (max-width: 1100px) {
      .stream-list-wrap{
          .content{
            .box{
              .item{
                .info-wrap{
                  .des{
                    height: 210px;
                  }
                }
              }
            }
          }
      }
    }
    @media screen and (max-width: 900px) {
      .stream-list-wrap{
          .content{
            padding: 10px;
            .box{
              .item{
                .info-wrap{
                  .des{
                    height: 250px;
                  }
                }
              }
            }
          }
      }
      .features{
        .ftu-text1,.ftu-text2{
          div{
            padding: 10px 10px 0 10px !important;
            height: 250px;
             span.small{
              padding: 0px 50px 0 0px !important;
             }
          }
         }
      }
    }
    @media screen and (max-width: 768px) {
      .stream-list-wrap{
          >.title {
            padding: 0 8% 0;
            font-size: 18px;
            margin: 30px 0 15px;
          }
          .content{
            overflow-x: scroll;
            overflow-y: hidden;
            .box{
              display: flex;
              flex-wrap: initial;
              width: 900px;
              justify-content: space-between;
              padding: 15px 5px 10px;
              .item{
                width: 160px;
                margin: 0 5px;
                box-sizing: border-box;
                padding: 8px;
                .img-wrap{
                  img{
                    max-width: 100%;
                  height: 68px;
                  }
                }
                .info-wrap{
                  .title{
                    font-size: 14px;
                    height: 30px;
                    text-align: left;
                    color: #000;
                  }
                  .des{
                    height: 170px;
                  }
                }
              }
            }
          }
          .dots-wrap{
            display: flex;
            justify-content: center;
            span{
              display: block;
              width: 8px;
              height: 8px;
              margin: 0 3px;
              border-radius: 50%;
              background-color: #dedede;
            }
            .active{
              background-color: #333;
            }
          }
      }
    }
    .features {
      margin-top: 80px;
      text-align: center;
      h4 {
        font-size: 36px;
        color: #333;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
      .ftu-text1,
      .ftu-text2 {
        display: flex;
        justify-content: space-between;
        text-align: left;
        div {
          width: 387px;
          height: 214px;
          padding: 30px 80px 0 20px;
          border: 1px solid #979797;
          background-repeat: no-repeat;
          background-position: 95% 90%;
          span {
            display: block;
            font-size: 18px;
            font-weight: 900;
            letter-spacing: 1.05px;
            line-height: 24px;
            color: #333;
          }
          span.small {
            margin-top: 20px;
            font-weight: 400;
            color: #333;
            font-size: 14px;
            line-height: 24px;
          }
        }
        div:nth-child(1) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon1.png);
        }
        div:nth-child(2) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon2.png);
        }
        div:nth-child(3) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon3.png);
        }
      }
      .ftu-text1 {
        margin-top: 40px;
      }
      .ftu-text2 {
        margin: 20px 0 0px;
        div:nth-child(1) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon4.png);
        }
        div:nth-child(2) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon5.png);
        }
        div:nth-child(3) {
          background-image: url(../../../../static/img/promotion/netflix-ftu-icon6.png);
        }
      }
    }

    @media screen and (max-width: 768px) {
      .features {
        padding: 20px 0;
        margin-top: 0;
        h4 {
          padding: 0 20px;
          font-size: 18px;
          color: #333;
          font-weight: 600;
          margin: 30px 0 20px;
          text-align: center;
        }
        .ftu-text1 {
          width: 90%;
          margin: 0 auto;
          justify-content: center;
          flex-wrap: wrap;
          div {
            margin-top: 0 !important;
            margin: 20px 0;
            padding: 18px 20px 0 20px;
            height: 190px;
          }
        }
        .ftu-text2 {
          width: 90%;
          margin: 0 auto;
          justify-content: center;
          flex-wrap: wrap;
          margin-bottom: 0 !important;
          div {
            margin-top: 0 !important;
            margin: 20px 0;
            padding: 18px 20px 0 20px;
            height: 180px;
          }
        }
      }
    }
  }

  .footer {
    position: relative;
    text-align: center;
    height: auto;
    margin: 80px auto 0;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    background-image: url(../../../../static/img/promotion/netflix-footer-bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: center;
    > img {
      max-width: 385px;
      top: -60px;
      position: relative;
    }
    p {
      font-size: 28px;
      color: #fff;
      font-weight: 600;
      margin: 0px 0 20px;
    }
    .down-btn {
      background: #fff;
      color: #a15ffe;
      margin-bottom: 100px;
    }
  }

  @media screen and (max-width: 768px) {
    .footer {
      > img {
        max-width: 80%;
        top: -60px;
        position: relative;
      }
      p {
        font-size: 22px;
        color: #fff;
        font-weight: 600;
        margin: 0px 0 20px;
      }
      .star-wrap {
        img {
          width: 30px;
        }
      }
    }
  }

  &.en-style{
    .container-top{
      .banner-wrap{
         .content{
          .left-wrap{
            .des {
              line-height: 36px;
            }
          }
         }
      }
    }

    .right-img {
      max-width: 630px;
    }
    .container{
      .whyneed-wrap{
        .content{
          text-align: center;
          .item{
            .des{
              line-height: 20px;
              margin: 20px 0;
            }
          }
        }
      }
      .benefit{
        .content{
          .box{
            .item{
              .des{
                font-size: 18px;
              }
            }
          }
        }
      }

      .stream-list-wrap{
        .content{
          .box{
           .item{
            .info-wrap{
              .des{
                height: 205px;
              }
            }
            .movie-wrap{
              .name{
                margin: 0;
              }
            }
           }
          }
        }
        .content2{
          .box{
           .item{
            .info-wrap{
              .des{
                height: 220px;
              }
            }
            .movie-wrap{
              .name{
                margin: 0;
              }
            }
           }
          }
        }
      }
      .features{
        .ftu-text1,.ftu-text2{
          div{
            padding: 20px 20px 0 20px;
            height: 230px;
            span{
              font-size: 16px;
              height: 48px;
            }
            span.small{
              line-height: 18px;
              height: auto;
              margin-top: 10px;
              padding: 0px 90px 0 0px;
            }
          }
        }
      }
    }

    @media screen and (max-width: 1440px) {
      .right-img {
        max-width: 600px;
      }
    }
    @media screen and (max-width: 1200px) {
      .container{
        .stream-list-wrap{
          .content{
            .box{
              .item{
                .info-wrap{
                  .des{
                    height: 280px;
                  }
                }
              }
            }
          }
        }

        .features{
          .ftu-text1,.ftu-text2{
            div{
              height: 250px;
              span{
              }
              span.small{
                padding: 0px 0px 0 0px;
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: 1000px) {
      .stream-list-wrap{
          .content{
            overflow-x: scroll;
            overflow-y: hidden;
            .box{
              display: flex;
              flex-wrap: initial;
              width: 1000px;
              justify-content: space-between;
              padding: 10px 0;
              .item{
                width: 170px;
                margin: 0 15px;
                box-sizing: border-box;
                padding: 10px;
                .img-wrap{
                  img{
                    max-width: 100%;
                  }
                }
                .info-wrap{
                  .des{
                    height: 180px;
                  }
                }
              }
            }
          }
          .content2{
            .box{
              .item{
                .info-wrap{
                  .des{
                    height: 310px;
                  }
                }
              }
            }
          }
      }
    }
    @media screen and (max-width: 768px) {
      .container-top{
        .banner-wrap{
          .content{
            .left-wrap{
              .des {
                line-height: 24px;
              }
            }
          }
        }
      }
      .stream-list-wrap{
          .content{
            .box{
              width: 800px;
              .item{
                width: 146px;
                margin: 0 5px;
                .info-wrap{
                  .des{
                    height: 240px !important;
                    font-size: 12px;
                  }
                }
              }
            }
          }
          .content2{
            .box{
              .item{
                .title{
                  height: 40px !important;
                }
                .info-wrap{
                  .des{
                    font-size: 12px;
                    height: 230px !important;
                  }
                }
              }
            }
          }
      }
      .features{
        .ftu-text1,.ftu-text2{
          div{
            padding: 20px 20px 0 20px;
            height: 220px !important;
            span{
              font-size: 16px;
              height: 48px;
            }
            span.small{
              line-height: 18px;
              height: auto;
              margin-top: 10px;
              padding: 0px 90px 0 0px;
            }
          }
        }
      }
      .container{
        .whyneed-wrap{
          .content{
            text-align: center;
            justify-content: center;
            .item{
              .des{
                line-height: 20px;
                margin: 20px 0;
              }
            }
          }
        }
      }
    }
  }
  .phone-show {
    display: none;
  }
  .pc-show {
    display: block;
  }
  @media screen and (max-width: 768px) {
    .phone-show {
      display: block;
    }
    .pc-show {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// StreamMedia.vue?42196745